import webapi, { WebapiOptions, WebapiParmas } from "../webapi";

// 搜索热词
export function getTopKeywords(payload: WebapiParmas, options?: WebapiOptions) {
	return webapi("api/v1/topKeywords/recommend", { ...payload }, options);
}
// 类目接口
export function getCategories(payload: WebapiParmas, options?: WebapiOptions) {
	return webapi("api/v1/categories/VelaHomePageCategories", { ...payload }, options);
}
// 购物车数量
export function getCartstore(payload: WebapiParmas, options?: WebapiOptions) {
	return webapi("api/v1/cartstore/get", { ...payload }, options);
}

/**
 * 获取search 自动匹配keywords
 * @param payload
 * @param options
 * @returns
 */
export function getKeywordsAutocomplete(payload: WebapiParmas = {}, options: WebapiOptions = {}) {
	return webapi(
		"api/v1/rest.app/vela/keywordsAutocomplete/vela.keywords.autocomplete.get",
		{
			...payload,
		},
		{ ...options },
	);
}
/**
 * 获取国家
 */
export interface CountryInfo {
	countryId: string;
	countryName: string;
	countryIsoCode2: string;
	countryIsoCode3: string;
	defaultCurrency: string;
	topSort?: string;
}

export interface GetCountriesResp {
	code: string;
	error_msg: any[];
	extInfo: any[];
	result: string;
	info: {
		countries: CountryInfo[];
		topCountries: CountryInfo[];
	};
}

export interface GetUnPaidOrderResp {
	code: string;
	error_msg: any[];
	extInfo: any[];
	result: string;
	info: {
		orders: any[];
		total_results: number;
	};
}

export interface GAEventType {
	eventCategory: string;
	eventAction: string;
}

export function getCountries(
	payload: WebapiParmas = {},
	options: WebapiOptions = {},
): Promise<GetCountriesResp> {
	return webapi(
		"api/v1/rest.app/vela/GetV2Countries/vela.sys.countries.get.v2",
		{
			...payload,
		},
		{ ...options },
	);
}
/**
 * 获取货币
 */

export interface CurrencyInfo {
	country_id: string;
	country_iso_code_2: string;
	country_iso_code_3: string;
	country_name: string;
	country_title: string;
	currency_code: string;
	currency_symbol: string;
	currency_text: string;
	currency_value: string;
	decimal_places: string;
	decimal_point: string;
	position: number;
	sort_order: number;
	symbol_left: string;
	symbol_right: string;
	thousands_point: string;
}
export interface GetCurrenciesResp {
	code: string;
	error_msg: any[];
	extInfo: any[];
	result: string;
	info: {
		currencies: CurrencyInfo[];
		new_currencies: CurrencyInfo[];
	};
}

export function getCurrencies(
	payload: WebapiParmas = {},
	options: WebapiOptions = {},
): Promise<GetCurrenciesResp> {
	return webapi(
		"api/v1/rest.app/vela/GetCurrencies/vela.sys.currencies.get",
		{
			...payload,
		},
		{ ...options },
	);
}
/**
 * 获取语言
 */

export interface LanguageInfo {
	language_code: string;
	language_id: number;
	language_name: string;
	language_text: string;
	position: number;
	seo_key: string;
}

export interface GeLanguagessResp {
	code: string;
	error_msg: any[];
	extInfo: any[];
	result: string;
	languages: LanguageInfo[];
}
export function getLanguages(
	payload: WebapiParmas = {},
	options: WebapiOptions = {},
): Promise<GeLanguagessResp> {
	return webapi(
		"api/v1/rest.app/vela/GetLanguages/vela.sys.languages.get",
		{
			...payload,
		},
		{ ...options },
	);
}

export interface UserProfile {
	user_id: number;
	email: string;
	default_country_id: number;
	country_id: number;
}
export interface GetUserProfileResp {
	code: string;
	error_msg: any[];
	extInfo: any[];
	result: string;
	info: {
		user: UserProfile;
	};
}
/**
 * 获取用户信息
 */
export function getUserProfile(
	payload: WebapiParmas = {},
	options: WebapiOptions = {},
): Promise<GetUserProfileResp> {
	return webapi(
		"api/v1/rest.app/vela/GetUserProfile/vela.user.profile.get",
		{
			...payload,
		},
		{ ...options },
	);
}
/**
 * 获取未支付订单
 */
export function getUnPaidOrder(payload: WebapiParmas = {}, options: WebapiOptions = {}) {
	return webapi(
		"api/v1/rest.app/vela/GetUnpaidOrder/vela.orders.get",
		{
			...payload,
			status_type: "1",
			page_size: "1",
			page_no: "1",
		},
		{ ...options },
	);
}
/**
 * 用户退出
 */
export function userLoginout(payload: WebapiParmas = {}, options: WebapiOptions = {}) {
	return webapi(
		"api/v1/rest.app/vela/UserLoginout/vela.user.logoff",
		{
			...payload,
		},
		{ ...options },
	);
}
// 搜索商品
export function getKeywordSearch(payload: WebapiParmas, options?: WebapiOptions) {
	return webapi(
		"api/rest/app_server.php",
		{ ...payload, method: "vela.keywords.autocomplete.get" },
		options,
	);
}

export function getInfo(payload: WebapiParmas, options?: WebapiOptions) {
	return webapi("api/v1/namespace/getInfo/vela.sys.countries.get.v2", { ...payload }, options);
}

export default {
	getTopKeywords,
	getCategories,
	getCartstore,
	getKeywordSearch,
	getInfo,
};
